export const getApiBase = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL || "";

  if (typeof window !== "undefined") {
    const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    if (isLocalhost) {
      if (window.location.port === "3000") {
        return configuredUrl ? `${configuredUrl.replace(/\/$/, "")}/api` : "http://127.0.0.1:8002/api";
      }
      return "/api";
    }
  }

  return configuredUrl ? `${configuredUrl.replace(/\/$/, "")}/api` : "/api";
};

export const API_BASE = getApiBase();
